import { Disclaimer } from './disclaimer';
export default Disclaimer;
